import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/dataCroper',
			name: 'dataCroper',
			component: () => import('@/page/person/account/dataCroper'),
		},
		{
			path: '/',
			redirect: '/index'
		}, {
			path: '/index', // index
			name: 'index',
			component: () => import('@/page/index/'),
			meta: {
				// title: '好爱学-国内中小学教育培训机构'
				title: '好爱学'
			}

		}, {
			path: '/strongMath',
			name: 'strongMath',
			component: () => import('@/page/strongMath'),
			meta: { title: '好爱学-强数学' }
		}, {
			path: '/loginCode', // 验证码登录
			name: 'loginCode',
			component: () => import('@/page/login/loginCode'),
			meta: {
				auth: true,
				title: '好爱学-验证码登录'
			}
		}, {
			path: '/loginPassword', // 密码登录
			name: 'loginPassword',
			component: () => import('@/page/login/loginPassword'),
			meta: {
				auth: true,
				title: '好爱学-密码登录'
			}
		}, {
			path: '/loginWeixin', // 微信登录
			name: 'loginWeixin',
			component: () => import('@/page/login/loginWeixin'),
			meta: {
				auth: true,
				title: '好爱学-微信登录'
			}
		}, {
			path: '/refundProtocol', // 退费协议
			name: 'refundProtocol',
			component: () => import('@/page/login/components/refundProtocol'),
			meta: {
				auth: true,
				title: '好爱学-收退费须知'
			}
		},
		{
			path: '/p-Data/:tab?',//个人资料
			name: 'data',
			component: () => import('@/page/person/account/data'),
			meta: {
				title: '好爱学-账号设置'
			}
		},{
			path: '/myCourseDetails',//我的课程详情页面
			name: 'myCourseDetails',
			component: () => import('@/page/person/course/myCourseDetails'),
			props: true,
			meta: {
				title: '好爱学-课程详情'
			}

		}, {
			path: '/myCourseChangeDetails/:type',//我的调课课程详情页面
			name: 'myCourseChangeDetails',
			component: () => import('@/page/person/course/myCourseChangeDetails'),
			props: true,
			meta: {
				title: '好爱学-调课课程详情'
			}
		}, {
			path: '/myOrderRetDetails',//我的退班订单详情
			name: 'myOrderRetDetails',
			component: () => import('@/page/person/order/myOrderRetDetails'),
			props: true,
			meta: {
				title: '好爱学-退班订单详情'
			}
		}, {
			path: '/myOrderTraDetails',//我的转班订单详情
			name: 'myOrderTraDetails',
			component: () => import('@/page/person/order/myOrderTraDetails'),
			props: true,
			meta: {
				title: '好爱学-转班订单详情'
			}
		}, {
			path: '/myOrderBuyDetails',//我的购课订单详情
			name: 'myOrderBuyDetails',
			component: () => import('@/page/person/order/myOrderBuyDetails'),
			props: true,
			meta: {
				title: '好爱学-购课订单详情'
			}
		}, {
			path: '/courseTraClass',//确认转班
			name: 'courseTraClass',
			component: () => import('@/page/person/course/courseTraClass'),
			meta: {
				title: '好爱学-确认转班'
			}
		}, {
			path: '/courseAdjClass',//确认调课
			name: 'courseAdjClass',
			component: () => import('@/page/person/course/courseAdjClass'),
			props: true,
			meta: {
				title: '好爱学-确认调课'
			}
		}, {
			path: '/myCourseRetireC',//退班
			name: 'myCourseRetireC',
			component: () => import('@/page/person/course/myCourseRetireC'),
			props: true,
			meta: {
				title: '好爱学-确认退班'
			}
		}, {
			path: '/courseRetireCSuc/:type',//调课/转班/退班成功
			name: 'courseRetireCSuc',
			component: () => import('@/page/person/course/courseRetireCSuc'),
			props: true,
			meta: {
				title: '好爱学-确认成功'
			}
		}, {
			path: '/courseTraCPayment',//在线支付
			name: 'courseTraCPayment',
			component: () => import('@/page/person/course/courseTraCPayment')
		}, {
			path: '/courseList/:type/',//课程列表
			name: 'courseList',
			component: () => import('@/page/person/course/courseList'),
			props: true,
			meta: {
				title: '好爱学-课程列表'
			}
		},
		{
			path: "/evaluateTeacher",
			name: "evaluateTeacher",
			component: () => import('@/page/person/evaluate/evaluateTeacher'),
			meta: {
				title: '好爱学-评价老师'
			},
			props: true
		}, {
			path: "/completed/:type/",
			name: "completed",
			component: () => import('@/page/person/evaluate/completed'),
			meta: {
				title: '好爱学-评价已完成'
			},
			props: true
		},
		// {
		// 	path: '/MyAssetssOther',//我的
		// 	component: () => import('@/page/person/MyAssetssOther'),
		// 	children: [
		// 		{
		// 			path: "",
		// 			component: () => import('@/page/person/myDatum'),
		// 		},
		// 		{
		// 			path: "myDatum/:tab?",
		// 			name: "myDatum",
		// 			component: () => import('@/page/person/myDatum'),
		// 			meta: {
		// 				title: '好爱学-我的资料'
		// 			}
		// 		},
		// 		{
		// 			path: "myScore/:tab?",
		// 			name: "myScore",
		// 			component: () => import('@/page/person/myScore'),
		// 			meta: {
		// 				title: '好爱学-我的成绩'
		// 			}
		// 		},
		// 		{
		// 			path: "myCoffers/:tab?",
		// 			name: "myCoffers",
		// 			component: () => import('@/page/person/coffers/myCoffers'),
		// 			meta: {
		// 				title: '好爱学-学习金库'
		// 			}
		// 		},
		// 		{
		// 			path: "liveLesson",
		// 			name: "liveLesson",
		// 			component: () => import('@/page/person/liveLesson'),
		// 			meta: {
		// 				title: '好爱学-直播课'
		// 			}
		// 		},
		// 	]
		// },
		{
			path: '/myAssets',//我的
			component: () => import('@/page/person/MyAssets'),
			children: [
				{
					path: "",
					component: () => import('@/page/person/courseForm/myCourseForm'),
				},
				{
					path: "myCourseForm",
					name: "myCourseForm",
					component: () => import('@/page/person/courseForm/myCourseForm'),
					meta: {
						title: '好爱学-课程表'
					}
				},
				// {
				// 	path: "myCourse",
				// 	name: "myCourse",
				// 	component: () => import('@/page/person/course/myCourse'),
				// 	meta: {
				// 		title: '好爱学-我的课程'
				// 	}
				// },
				{
					path: "myRecord/:tab?",
					name: "myRecord",
					component: () => import('@/page/person/record/myRecord'),
					meta: {
						title: '好爱学-转调班记录'
					}
				},
				{
					path: "myResubmit",
					name: "myResubmit",
					component: () => import('@/page/person/MyResubmit'),
					meta: {
						title: '好爱学-课程续报'
					}
				},
				{
					path: "myOrder/:tab?",
					name: "myOrder",
					component: () => import('@/page/person/order/myOrder'),
					meta: {
						title: '好爱学-我的订单'
					}
				},
				{
					path: "myDatum/:tab?",
					name: "myDatum",
					component: () => import('@/page/person/myDatum'),
					meta: {
						title: '我的资料'
					}
				},
				{
					path: "myScore/:tab?",
					name: "myScore",
					component: () => import('@/page/person/myScore'),
					meta: {
						title: '好爱学-我的成绩'
					}
				},
				{
					path: "myCoffers/:tab?",
					name: "myCoffers",
					component: () => import('@/page/person/coffers/myCoffers'),
					meta: {
						title: '好爱学-学习金库'
					}
				},
				{
					path: "liveLesson",
					name: "liveLesson",
					component: () => import('@/page/person/liveLesson'),
					meta: {
						title: '好爱学-直播课'
					}
				},
				{
					path: "myCoupon",
					name: "myCoupon",
					component: () => import('@/page/person/MyCoupon'),
					meta: {
						title: '好爱学-优惠券'
					}
				},
				{
					path: "myGaosicoin",
					name: "myGaosicoin",
					component: () => import('@/page/person/MyGaosicoin'),
					meta: {
						title: '好爱学-学币'
					}
				},
				{
					path: "mySurplusFee",
					name: "mySurplusFee",
					component: () => import('@/page/person/MySurplusFee'),
					meta: {
						title: '好爱学-余费'
					}
				},
				{
					path: "evaluateDetsils/:tab?",
					name: "evaluateDetsils",
					component: () => import('@/page/person/evaluate/evaluateDetsils'),
					meta: {
						title: '好爱学-我的评价'
					}
				},
				{
					path: "myFollow",
					name: "myFollow",
					component: () => import('@/page/person/myFollow'),
					meta: {
						title: '好爱学-我的关注'
					}
				},
			]
		},{
			path: "/liveCourse/:courseId/:userCourseStatus",
			name: "liveCourse",
			component: () => import('@/page/myCourse/liveCourse'),
			meta: {
				title: '好爱学-在线课程'
			},
		},{
			path: "/liveCourse1/:courseId/:userCourseStatus/:cardCode",
			name: "liveCourse1",
			component: () => import('@/page/myCourse/liveCourse1'),
			meta: {
				title: '好爱学-在线课程'
			},
		},{
			path: "/detail/:classId",
			name: "liveDetail",
			component: () => import('@/page/myCourse/detail'),
			meta: {
				title: '好爱学-直播'
			},
		},
		// “去上课”入口暂时停用
		// {
		// 	path: '/couresIndex',
		// 	name: 'couresIndex',
		// 	component: () => import('@/page/coures/couresIndex'),
		// 	meta: {
		// 		title: '好爱学-课程列表'
		// 	}
		// },
		{
			path: '/couresVideo',
			name: 'couresVideo',
			component: () => import('@/page/coures/couresVideo'),
			meta: {
				title: '好爱学-高思在线'
			}
		},
		//  {
		// 	path: '/couresDetail',
		// 	name: 'couresDetail',
		// 	component: () => import('@/page/coures/couresDetail'),
		// 	meta: {
		// 		title: '好爱学-课程详情'
		// 	}
		// },
		 {
			path: '/schoolIndex',
			name: 'schoolIndex',
			component: () => import('@/page/school/schoolIndex'),
			meta: {
				title: '好爱学-校区分布'
			}
		}, {
			path: '/schoolDetail',
			name: 'schoolDetail',
			component: () => import('@/page/school/schoolDetail'),
			meta: {
				title: '好爱学-校区详情'
			}
		}, {
			path: '/cart',
			name: 'cart',
			component: () => import('@/page/shopping/cart'),
			meta: {
				title: '好爱学-选课单'
			}
		}, {
			path: '/order',
			name: 'order',
			component: () => import('@/page/shopping/order'),
			meta: {
				title: '好爱学-确认订单'
			}
		}, {
			path: '/payIndex',
			name: 'payIndex',
			component: () => import('@/page/shopping/payIndex'),
			meta: {
				title: '好爱学-在线支付'
			}
		}, {
			path: '/payWeixin',
			name: 'payWeixin',
			component: () => import('@/page/shopping/payWeixin'),
			meta: {
				title: '好爱学-微信支付'
			}
		}, {
			path: '/paySucces',
			name: 'paySucces',
			component: () => import('@/page/shopping/paySucces'),
			meta: {
				title: '好爱学-支付成功'
			}
		}, {
			path: '/message',
			name: 'message',
			component: () => import('@/page/news/message'),
			meta: {
				title: '好爱学-我的消息'
			}
		},
		{
			path: "/liveQa",
			name: "liveQa",
			component: () => import('@/page/person/course/qa'),
			meta: {
				title: '好爱学-常见问题'
			}
		}, {
			path: '/teachersTeam',
			name: 'teachersTeam',
			component: () => import('@/page/teachers/teachersTeam'),
			meta: {
				title: '好爱学-师资团队'
			}
		}, {
			path: '/downApp',
			name: 'downApp',
			component: () => import('@/page/news/downApp'),
			meta: {
				title: '好爱学-app下载'
			}
		}, {
			path: '/feedback',
			name: 'feedback',
			component: () => import('@/page/news/feedback'),
			meta: {
				title: '好爱学-意见反馈'
			}
		}, {
			path: '/about',
			name: 'about',
			component: () => import('@/page/news/about'),
			meta: {
				title: '好爱学-关于我们'
			}
		}, {
			path: '/contact',
			name: 'contact',
			component: () => import('@/page/news/contact'),
			meta: {
				title: '好爱学-联系我们'
			}
		}, {
			path: '/recordConten',
			name: 'recordConten',
			component: () => import('@/page/news/recordConten'),
			meta: {
				title: '好爱学-备案内容承诺公示'
			}
		}, {
			path: '/normsStatement',
			name: 'normsStatement',
			component: () => import('@/page/news/normsStatement'),
			meta: {
				title: '好爱学-好爱学声明'
			}
		}
		, {
			path: '/tixiDetail',
			name: 'tixiDetail',
			component: () => import('@/page/tixi/tixiDetail'),
			meta: {
				title: '好爱学-课程体系'
			}
		}
		, {
			path: '/tixiHead',
			name: 'tixiHead',
			component: () => import('@/page/tixi/tixiHead'),
			meta: {
				title: '好爱学-课程体系'
			},
			children: [
				{
					path: "",
					component: () => import('@/page/tixi/primaryIndex'),
					meta: {
						title: '好爱学-小学课程'
					}
				},
				{
					path: 'primaryIndex',
					name: 'primaryIndex',
					component: () => import('@/page/tixi/primaryIndex'),
					meta: {
						title: '好爱学-小学课程'
					}
				}, {
					path: 'middleIndex',
					name: 'middleIndex',
					component: () => import('@/page/tixi/middleIndex'),
					meta: {
						title: '好爱学-初中课程'
					}
				}, {
					path: 'highIndex',
					name: 'highIndex',
					component: () => import('@/page/tixi/highIndex'),
					meta: {
						title: '好爱学-高中课程'
					}
				},
			]
		},
		{
			path: '/productServe',
			name: 'productServe',
			component: () => import('@/page/productServe/sever'),
			meta: {
				title: '好爱学-产品服务'
			},
			children: [
				{
					path: "",
					component: () => import('@/page/productServe/shuxue'),
					meta: {
						title: '好爱学-高斯数学'
					}
				},
				{
					path: 'shuxue',
					name: 'shuxue',
					component: () => import('@/page/productServe/shuxue'),
					meta: {
						title: '好爱学-高斯数学'
					}
				},
				{
					path: 'yuwen',
					name: 'yuwen',
					component: () => import('@/page/productServe/yuwen'),
					meta: {
						title: '好爱学-思泉语文'
					}
				},
				{
					path: 'yingyu',
					name: 'yingyu',
					component: () => import('@/page/productServe/xiaoxue-yingyu'),
					meta: {
						title: '好爱学-思高英语'
					}
				},
				{
					path: 'zxyingyu',
					name: 'zxyingyu',
					component: () => import('@/page/productServe/zhongxue-yingyu'),
					meta: {
						title: '好爱学-思高英语'
					}
				},
				{
					path: 'wuli',
					name: 'wuli',
					component: () => import('@/page/productServe/wuli'),
					meta: {
						title: '好爱学-元本物理'
					}
				},{
					path: 'huaxue',
					name: 'huaxue',
					component: () => import('@/page/productServe/huaxue'),
					meta: {
						title: '好爱学-点燃化学'
					}
				},{
					path: 'shengwu',
					name: 'shengwu',
					component: () => import('@/page/productServe/shengwu'),
					meta: {
						title: '好爱学-显微生物'
					}
				},{
					path: 'steam',
					name: 'steam',
					component: () => import('@/page/productServe/steam'),
					meta: {
						title: '好爱学-高思STEAM'
					}
				}
			]

		},
		{
			path: '/secretPage',
			name: 'secretPage',
			component: () => import('@/page/index/secretPage'),
			meta: {
				title: '好爱学-国内中小学教育培训机构'
			}
		}
	],
	// 点击跌幅 定位问题
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}

	//解决锚dian问题
	// mode: 'history',
	// scrollBehavior (to, from, savedPosition) {
	//   console.log('to', to)
	//   if (to.hash) {
	//     return {
	//       selector: to.hash
	//     }
	//   }
	// }
})



// WEBPACK FOOTER //
// ./src/router/index.js